module.exports = __webpack_public_path__ + "images/d431c9893c2852f641569fbe4d0516f6c23e10e33d95099a0a3ce36ffc5615ef.svg";